import * as React from "react";
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import PageLayout from './components/Layout';
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { appRoles } from "./authConfig";
import './custom.css'
import "./styles/App.css";
import CustomerSubscriptionListPage from "./components/pages/CustomerSubscriptionListPage";
import CustomerListPage from "./components/pages/CustomerListPage";
import CustomerProfilePage from "./components/pages/CustomerProfilePage";
import CustomerDetailPage from "./components/pages/CustomerDetailPage";
import DetailStatementPage from "./components/pages/DetailStatementPage";
import TicketListPage from "./components/pages/TicketListPage";
import TicketPage from "./components/pages/TicketPage";
import { RouteGuard } from "./components/RouteGuard";
import { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import configureStore from "./store/configureStore";
import { createBrowserHistory } from "history";
import { IPublicClientApplication } from "@azure/msal-browser";
import PricingPage from "./components/pages/PricingPage";
import Home from "./components/Home";
import TicketListPageExternal from "./components/pages/TicketListPageExternal";
import TicketPageExternal from "./components/pages/TicketPageExternal";
import UserPage from "./components/pages/UserPage";
import ServicePageExternal from "./components/pages/ServicePageExternal";
import ReportPage from "./components/pages/ReportPage";
import ReportPageExternal from "./components/pages/ReportPageExternal";

/**
 * If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
 */

const Pages = ({ instance }: { instance: IPublicClientApplication }) => {
    return (
          <Switch>
                <RouteGuard
                    exact path='/'
                roles={[appRoles.SuperAdmin, appRoles.CompanyAdmin]}
                Component={Home} />
                <RouteGuard
                    path='/customer-list'
                    roles={[appRoles.SuperAdmin]}
                    Component={CustomerListPage} />
                <RouteGuard
                    path='/customer-detail/:id?'
                    roles={[appRoles.SuperAdmin]}
                    Component={CustomerDetailPage} />
                <RouteGuard
                    path='/customer-profile/:id?'
                    roles={[appRoles.SuperAdmin]}
                    Component={CustomerProfilePage} />
                <RouteGuard
                    path='/subscription-list/:id?'
                    roles={[appRoles.SuperAdmin]}
                    Component={CustomerSubscriptionListPage} />
                <RouteGuard
                    path='/statement-detail/:id?'
                    roles={[appRoles.SuperAdmin]}
                    Component={DetailStatementPage} />
                <RouteGuard
                    path='/ticket-list/'
                    roles={[appRoles.SuperAdmin, appRoles.CompanyAdmin]}
                    Component={TicketListPage} />
                <RouteGuard
                    path='/user-tickets/:id?'
                    roles={[appRoles.CompanyAdmin]}
                    Component={TicketListPageExternal} />
                <RouteGuard
                    path='/userticket/:id?'
                    roles={[appRoles.CompanyAdmin]}
                    Component={TicketPageExternal} />
                <RouteGuard
                    path='/ticket/:id?'
                    roles={[appRoles.SuperAdmin]}
                    Component={TicketPage} />
                <RouteGuard
                    path='/pricing'
                    roles={[appRoles.SuperAdmin]}
                    Component={PricingPage} />
                <RouteGuard
                    path='/users'
                    roles={[appRoles.SuperAdmin]}
                Component={UserPage} />
                <RouteGuard
                    path='/report'
                    roles={[appRoles.SuperAdmin]}
                    Component={ReportPage} />
                 {/*<RouteGuard*/}
                 {/*   path='/user-report'*/}
                 {/*   roles={[appRoles.CompanyAdmin]}*/}
                 {/*   Component={ReportPageExternal} />*/}
                <RouteGuard
                path='/user-services'
                roles={[appRoles.CompanyAdmin]}
                Component={ServicePageExternal} />
                {/*<Route path='/fetch-data/:startDateIndex?' component={FetchData} />*/}
            </Switch>
    );
};

const App = ({ instance } : { instance: IPublicClientApplication }) => {

    // Create browser history to use in the Redux store
    const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
    const history = createBrowserHistory({ basename: baseUrl });

    // Get the application-wide store instance, prepopulating with state from the server where available.
    const store = configureStore(history);

    return (
         <Router>
            <MsalProvider instance={instance}>
                <Provider store={store}>
                    <ConnectedRouter history={history}>
                        <PageLayout>                          
                            <Pages instance={instance} />
                        </PageLayout>
                    </ConnectedRouter>
                </Provider>
            </MsalProvider>
        </Router>
    );
};

export default App;